<template>
  <v-app class="back">
    <v-container fluid class="doc mt-n1 ml-1">
      <v-row justify="center">
        <v-col class="mt-1" md="12">
          <v-row>
            <v-col md="8">
              <span class="display-1 titulo font-weight-bold">Categorias</span>
            </v-col>
            <v-spacer></v-spacer>
            <v-col md="auto">
              <v-btn
                @click="dialog_categoria = true"
                rounded
                class="white--text"
                color="#283480"
                v-if="editModulo"
              >Adicionar nova categoria</v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <!-- LISTAGEM -->
      <v-row>
        <v-col cols="12" sm="6" md="4" class>
          <span class="black--text title font-weight-bold">
            <v-row>
              <v-col>Receita</v-col>
            </v-row>
          </span>
          <v-card outlined class="borda" flat width="100%">
            <v-list>
              <v-list-group
                :append-icon="item.pai.length > 0 ? '$expand':''"
                v-for="(item, index) in receita"
                :key="index"
                v-model="item.active"
              >
                <template v-slot:activator>
                  <v-list-item-content class="py-0">
                    <v-list-item-title class="py-0">
                      <v-row class="py-0">
                        <v-col md="auto" sm="auto" cols="auto">
                          <span>{{item.categoria_nome}}</span>
                        </v-col>
                        <v-spacer class="py-0"></v-spacer>
                        <v-col md="auto" sm="auto" cols="auto" class="py-0">
                          <v-tooltip top color="black" v-if="item.categoria_fixa && editModulo">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn icon v-bind="attrs" v-on="on" text>
                                <v-icon>mdi-information-outline</v-icon>
                              </v-btn>
                            </template>
                            <span>
                              Não é possível
                              <span class="orange--text">editar</span> ou
                              <span class="red--text">excluir</span> categorias fixas
                            </span>
                          </v-tooltip>

                          <v-tooltip top color="black" v-if="!editModulo">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn icon v-bind="attrs" v-on="on" text>
                                <v-icon>mdi-information-outline</v-icon>
                              </v-btn>
                            </template>
                            <span>
                              Sem autorização para
                              <span class="orange--text">editar</span> ou
                              <span class="red--text">excluir</span>
                            </span>
                          </v-tooltip>

                          <v-menu offset-x v-if="!item.categoria_fixa && editModulo">
                            <template v-slot:activator="{ on }">
                              <v-btn icon text v-on="on">
                                <v-icon>mdi-dots-vertical</v-icon>
                              </v-btn>
                            </template>
                            <v-list>
                              <div v-for="(iten, index) in opcoes" :key="index">
                                <v-list-item @click="menu(iten, item)">
                                  <v-icon>{{ iten.icon }}</v-icon>
                                  <v-list-item-title>{{ iten.nome }}</v-list-item-title>
                                </v-list-item>
                              </div>
                            </v-list>
                          </v-menu>
                        </v-col>
                      </v-row>
                    </v-list-item-title>
                  </v-list-item-content>
                </template>

                <v-list-item v-for="(filho, i) in item.pai ? item.pai : []" :key="i">
                  <v-list-item-content>
                    <v-list-item-title class="ml-6">
                      <v-row class="py-0">
                        <v-col md="auto" sm="auto" cols="auto">
                          <span>{{filho.categoria_nome}}</span>
                        </v-col>
                        <v-spacer class="py-0"></v-spacer>
                        <v-col md="auto" sm="auto" cols="auto" class="py-0">
                          <v-tooltip top color="black" v-if="filho.categoria_fixa && editModulo">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn icon v-bind="attrs" v-on="on" text>
                                <v-icon>mdi-information-outline</v-icon>
                              </v-btn>
                            </template>
                            <span>
                              Não é possível
                              <span class="orange--text">editar</span> ou
                              <span class="red--text">excluir</span> categorias fixas
                            </span>
                          </v-tooltip>

                          <v-tooltip top color="black" v-if="!editModulo">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn icon v-bind="attrs" v-on="on" text>
                                <v-icon>mdi-information-outline</v-icon>
                              </v-btn>
                            </template>
                            <span>
                              Sem autorização para
                              <span class="orange--text">editar</span> ou
                              <span class="red--text">excluir</span>
                            </span>
                          </v-tooltip>

                          <v-menu offset-x v-if="!filho.categoria_fixa && editModulo">
                            <template v-slot:activator="{ on }">
                              <v-btn icon text v-on="on">
                                <v-icon>mdi-dots-vertical</v-icon>
                              </v-btn>
                            </template>
                            <v-list>
                              <div v-for="(iten, index) in opcoes" :key="index">
                                <v-list-item @click="menu(iten, filho)">
                                  <v-icon>{{ iten.icon }}</v-icon>
                                  <v-list-item-title>{{ iten.nome }}</v-list-item-title>
                                </v-list-item>
                              </div>
                            </v-list>
                          </v-menu>
                        </v-col>
                      </v-row>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
              </v-list-group>
            </v-list>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <span class="black--text title font-weight-bold">
            <v-row>
              <v-col>Despesa</v-col>
            </v-row>
          </span>
          <v-card outlined class="borda" flat width="100%">
            <v-list>
              <v-list-group
                :append-icon="item.pai.length > 0 ? '$expand':''"
                v-for="(item, index) in despesa"
                :key="index"
                v-model="item.active"
              >
                <template v-slot:activator>
                  <v-list-item-content class="py-0">
                    <v-list-item-title class="py-0">
                      <v-row class="py-0">
                        <v-col md="auto" sm="auto" cols="auto">
                          <span>{{item.categoria_nome}}</span>
                        </v-col>
                        <v-spacer class="py-0"></v-spacer>
                        <v-col md="auto" sm="auto" cols="auto" class="py-0">
                          <v-tooltip top color="black" v-if="item.categoria_fixa && editModulo">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn icon v-bind="attrs" v-on="on" text>
                                <v-icon>mdi-information-outline</v-icon>
                              </v-btn>
                            </template>
                            <span>
                              Não é possível
                              <span class="orange--text">editar</span> ou
                              <span class="red--text">excluir</span> categorias fixas
                            </span>
                          </v-tooltip>

                          <v-tooltip top color="black" v-if="!editModulo">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn icon v-bind="attrs" v-on="on" text>
                                <v-icon>mdi-information-outline</v-icon>
                              </v-btn>
                            </template>
                            <span>
                              Sem autorização para
                              <span class="orange--text">editar</span> ou
                              <span class="red--text">excluir</span>
                            </span>
                          </v-tooltip>

                          <v-menu offset-x v-if="!item.categoria_fixa && editModulo">
                            <template v-slot:activator="{ on }">
                              <v-btn icon text v-on="on">
                                <v-icon>mdi-dots-vertical</v-icon>
                              </v-btn>
                            </template>
                            <v-list>
                              <div v-for="(iten, index) in opcoes" :key="index">
                                <v-list-item @click="menu(iten, item)">
                                  <v-icon>{{ iten.icon }}</v-icon>
                                  <v-list-item-title>{{ iten.nome }}</v-list-item-title>
                                </v-list-item>
                              </div>
                            </v-list>
                          </v-menu>
                        </v-col>
                      </v-row>
                    </v-list-item-title>
                  </v-list-item-content>
                </template>

                <v-list-item v-for="(filho, i) in item.pai ? item.pai : []" :key="i">
                  <v-list-item-content>
                    <v-list-item-title class="ml-6">
                      <v-row class="py-0">
                        <v-col md="auto">
                          <span>{{filho.categoria_nome}}</span>
                        </v-col>
                        <v-spacer class="py-0"></v-spacer>
                        <v-col md="auto" class="py-0">
                          <v-tooltip top color="black" v-if="filho.categoria_fixa && editModulo">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn icon v-bind="attrs" v-on="on" text>
                                <v-icon>mdi-information-outline</v-icon>
                              </v-btn>
                            </template>
                            <span>
                              Não é possível
                              <span class="orange--text">editar</span> ou
                              <span class="red--text">excluir</span> categorias fixas
                            </span>
                          </v-tooltip>

                          <v-tooltip top color="black" v-if="!editModulo">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn icon v-bind="attrs" v-on="on" text>
                                <v-icon>mdi-information-outline</v-icon>
                              </v-btn>
                            </template>
                            <span>
                              Sem autorização para
                              <span class="orange--text">editar</span> ou
                              <span class="red--text">excluir</span>
                            </span>
                          </v-tooltip>

                          <v-menu offset-x v-if="!filho.categoria_fixa && editModulo">
                            <template v-slot:activator="{ on }">
                              <v-btn icon text v-on="on">
                                <v-icon>mdi-dots-vertical</v-icon>
                              </v-btn>
                            </template>
                            <v-list>
                              <div v-for="(iten, index) in opcoes" :key="index">
                                <v-list-item @click="menu(iten, filho)">
                                  <v-icon>{{ iten.icon }}</v-icon>
                                  <v-list-item-title>{{ iten.nome }}</v-list-item-title>
                                </v-list-item>
                              </div>
                            </v-list>
                          </v-menu>
                        </v-col>
                      </v-row>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
              </v-list-group>
            </v-list>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="4" class>
          <span class="black--text title font-weight-bold">
            <v-row>
              <v-col>Transação</v-col>
            </v-row>
          </span>
          <v-card outlined class="borda" flat width="100%">
            <v-list>
              <v-list-group
                :append-icon="item.pai.length > 0 ? '$expand':''"
                v-for="(item, index) in transacao"
                :key="index"
                v-model="item.active"
              >
                <template v-slot:activator>
                  <v-list-item-content class="py-0">
                    <v-list-item-title class="py-0">
                      <v-row class="py-0">
                        <v-col md="auto">
                          <span>{{item.categoria_nome}}</span>
                        </v-col>
                        <v-spacer class="py-0"></v-spacer>
                        <v-col md="auto" class="py-0">
                          <v-tooltip top color="black" v-if="item.categoria_fixa && editModulo">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn icon v-bind="attrs" v-on="on" text>
                                <v-icon>mdi-information-outline</v-icon>
                              </v-btn>
                            </template>
                            <span>
                              Não é possível
                              <span class="orange--text">editar</span> ou
                              <span class="red--text">excluir</span> categorias fixas
                            </span>
                          </v-tooltip>

                          <v-tooltip top color="black" v-if="!editModulo">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn icon v-bind="attrs" v-on="on" text>
                                <v-icon>mdi-information-outline</v-icon>
                              </v-btn>
                            </template>
                            <span>
                              Sem autorização para
                              <span class="orange--text">editar</span> ou
                              <span class="red--text">excluir</span>
                            </span>
                          </v-tooltip>

                          <v-menu offset-x v-if="!item.categoria_fixa && editModulo">
                            <template v-slot:activator="{ on }">
                              <v-btn icon text v-on="on">
                                <v-icon>mdi-dots-vertical</v-icon>
                              </v-btn>
                            </template>
                            <v-list>
                              <div v-for="(iten, index) in opcoes" :key="index">
                                <v-list-item @click="menu(iten, item)">
                                  <v-icon>{{ iten.icon }}</v-icon>
                                  <v-list-item-title>{{ iten.nome }}</v-list-item-title>
                                </v-list-item>
                              </div>
                            </v-list>
                          </v-menu>
                        </v-col>
                      </v-row>
                    </v-list-item-title>
                  </v-list-item-content>
                </template>

                <v-list-item v-for="(filho, i) in item.pai ? item.pai : []" :key="i">
                  <v-list-item-content>
                    <v-list-item-title class="ml-6">
                      <v-row class="py-0">
                        <v-col md="auto">
                          <span>{{filho.categoria_nome}}</span>
                        </v-col>
                        <v-spacer class="py-0"></v-spacer>
                        <v-col md="auto" class="py-0">
                          <v-tooltip top color="black" v-if="filho.categoria_fixa && editModulo">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn icon v-bind="attrs" v-on="on" text>
                                <v-icon>mdi-information-outline</v-icon>
                              </v-btn>
                            </template>
                            <span>
                              Não é possível
                              <span class="orange--text">editar</span> ou
                              <span class="red--text">excluir</span> categorias fixas
                            </span>
                          </v-tooltip>

                          <v-tooltip top color="black" v-if="!editModulo">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn icon v-bind="attrs" v-on="on" text>
                                <v-icon>mdi-information-outline</v-icon>
                              </v-btn>
                            </template>
                            <span>
                              Sem autorização para
                              <span class="orange--text">editar</span> ou
                              <span class="red--text">excluir</span>
                            </span>
                          </v-tooltip>

                          <v-menu offset-x v-if="!filho.categoria_fixa && editModulo">
                            <template v-slot:activator="{ on }">
                              <v-btn icon text v-on="on">
                                <v-icon>mdi-dots-vertical</v-icon>
                              </v-btn>
                            </template>
                            <v-list>
                              <div v-for="(iten, index) in opcoes" :key="index">
                                <v-list-item @click="menu(iten, filho)">
                                  <v-icon>{{ iten.icon }}</v-icon>
                                  <v-list-item-title>{{ iten.nome }}</v-list-item-title>
                                </v-list-item>
                              </div>
                            </v-list>
                          </v-menu>
                        </v-col>
                      </v-row>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
              </v-list-group>
            </v-list>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <!-- DIALOG COR -->
    <v-dialog v-model="dialog_cor" persistent max-width="350">
      <v-card class="borda" flat>
        <v-card-text class="pt-7">
          <v-color-picker v-model="nova_categoria.categoria_cor" hide-inputs></v-color-picker>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            style="background-color: #283480  !important; color:#00FFD4  !important"
            rounded
            @click="dialog_cor = false"
          >OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOG CADASTRAR/edit -->
    <v-dialog v-model="dialog_categoria" persistent width="500">
      <v-form ref="form" v-model="valid" @submit.prevent="save()">
        <v-card class="borda" flat width="100%">
          <v-card-title class="ma-2">
            <span v-if="!nova_categoria.id_categoria">Nova categoria</span>
            <span v-else>Editar categoria</span>
            <v-spacer></v-spacer>
            <v-btn icon text @click="close()">
              <v-icon>mdi-close-thick</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <span class="black--text font-weight-bold">Cor *</span>
                <v-btn
                  fab
                  x-small
                  class="ml-2"
                  @click="dialog_cor = true"
                  :color="nova_categoria.categoria_cor"
                ></v-btn>
              </v-col>
              <v-col cols="12">
                <span class="black--text font-weight-bold">Tipo(s) *</span>
                <v-select
                  class="mb-n7"
                  solo
                  dense
                  flat
                  required
                  :rules="requiredRules"
                  item-color="#283480"
                  outlined
                  :items="select_tipos"
                  v-model="nova_categoria.tipo_lancamento"
                  :multiple="true"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <span class="black--text font-weight-bold">Nome *</span>
                <v-text-field
                  class="mb-n7"
                  v-model="nova_categoria.categoria_nome"
                  dense
                  outlined
                  :rules="requiredRules"
                  solo
                  flat
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <span class="font-weight-bold black--text">Vincular</span>
                <v-select
                  class="mb-n7"
                  solo
                  dense
                  flat
                  outlined
                  clearable
                  v-model="vincular"
                  label="Selecione"
                  :items="listVinculos"
                  @change="vinculoAlterado()"
                ></v-select>
              </v-col>
              <v-col cols="12" v-if="nova_categoria.categoria_entidade">
                <span class="font-weight-bold black--text">Entidade padrão</span>
                <v-autocomplete
                  v-model="nova_categoria.categoria_entidade_padrao"
                  no-data-text="Nenhum registro encontrado"
                  solo
                  label="Selecione"
                  dense
                  :items="entidades"
                  item-value="id_entidade"
                  item-text="entidade_nome"
                  flat
                  outlined
                  clearable
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row v-if="temPai()">
              <v-col cols="12">
                <span class="black--text font-weight-bold">Categoria pai</span>
                <v-select
                  class="mb-n7"
                  clearable
                  solo
                  item-color="#283480"
                  v-model="nova_categoria.categoria_pai"
                  outlined
                  dense
                  flat
                  placeholder="Sem categoria pai"
                  :items="select_categoria"
                ></v-select>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-row class="mb-4" no-gutters justify="center">
              <v-btn
                class="mr-2"
                rounded
                style="color: #283480 !important"
                outlined
                :disabled="loading"
                @click="close()"
              >Cancelar</v-btn>
              <v-btn
                class="ml-2"
                rounded
                :disabled="loading"
                :loading="loading"
                style="background-color: #283480  !important; color:#00FFD4  !important"
                @click="save()"
              >
                <v-icon>mdi-content-save</v-icon>
                <span>Salvar</span>
              </v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <!-- DIALOG EXCLUIR -->
    <v-dialog v-model="dialog_delete" persistent max-width="400">
      <v-card class="borda" flat>
        <v-card-title class="headline">Tem certeza que deseja deletar esta conta?</v-card-title>
        <v-card-text>Se deletar esta conta ela não poderá ser recuperada!!</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outlined rounded color="#283480" @click="dialog_delete = false">Cancelar</v-btn>
          <v-btn
            style="background-color: #283480  !important; color:#00FFD4  !important"
            rounded
            @click="deleteItem(), dialog_delete = false"
          >Sim, tenho certeza</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import Api from "@/common/api.helper";
export default {
  data: () => ({
    items_per_pag_receita: 10,
    items_per_pag_transacao: 10,
    items_per_pag_despesa: 10,
    dialog_delete: false,
    dialog_cor: false,
    expanded: [true, true, true],
    loading: false,
    select_categoria: [],
    vincular: "",
    listVinculos: [
      { text: "Entidade", value: "entidade" },
      { text: "Associado", value: "associado" }
    ],
    sem_registro: "Nenhum registro encontrado",
    valid: true,
    validEdit: true,
    requiredRules: [v => !!v || "Campo Obrigatório."],
    dialog_edit_categoria: false,
    dialog_categoria: false,
    opcoes: [
      { nome: "⠀Editar", icon: "mdi-pencil-outline" },
      { nome: "⠀Excluir", icon: "mdi-delete-outline" }
    ],
    select_tipos: [
      { text: "Receita", value: 1 },
      { text: "Despesa", value: 2 },
      { text: "Transação", value: 3 }
    ],
    despesa: [],
    receita: [],
    transacao: [],
    entidades: [],
    nova_categoria: {
      categoria_nome: "",
      categoria_entidade: 0,
      categoria_associado: 0,
      categoria_cor: "#000000",
      categoria_entidade_padrao: "",
      tipo_lancamento: null,
      categoria_pai: null
    },
    formData: [],
    cabecalho: [
      { text: "Categoria", align: "start", value: "categoria_nome" },
      { text: "Ações", align: "end", value: "acoes" }
    ],
    editModulo: false
  }),
  methods: {
    menu(opcao, item) {
      this.formData.id_categoria = item.id_categoria;
      if (opcao.nome === "⠀Excluir") {
        this.dialog_delete = true;
      } else if (opcao.nome === "⠀Editar") {
        this.select_categoria = [];
        for (let i = 0; i < item.tipos.length; i++) {
          if (item.tipos[i].id_tipo_lancamento == 1) {
            this.pushCategoriasPai("receita");
          }
          if (item.tipos[i].id_tipo_lancamento == 2) {
            this.pushCategoriasPai("despesa");
          }
          if (item.tipos[i].id_tipo_lancamento == 3) {
            this.pushCategoriasPai("transacao");
          }
        }
        for (let i = 0; i < this.select_categoria.length; i++) {
          if (item.id_categoria == this.select_categoria[i].value) {
            this.select_categoria.splice(i, 1);
          }
        }

        this.nova_categoria = item;
        this.nova_categoria.tipo_lancamento = [];
        for (let i = 0; i < item.tipos.length; i++) {
          this.nova_categoria.tipo_lancamento.push(
            item.tipos[i].id_tipo_lancamento
          );
        }
        if (this.nova_categoria.categoria_entidade) {
          this.vincular = "entidade";
        }
        if (this.nova_categoria.categoria_associado) {
          this.vincular = "associado";
        }
        this.dialog_categoria = true;
      }
    },
    pushCategoriasPai(tipo) {
      for (let i = 0; i < this.formData[tipo].length; i++) {
        this.select_categoria.push({
          text: this.formData[tipo][i].categoria_nome,
          value: this.formData[tipo][i].id_categoria
        });
      }
    },
    getCategorias() {
      Api.get(`/categorias-lancamentos/config`)
        .then(response => {
          if (response.data) {
            this.select_categoria = [];
            this.formData = response.data;
            this.despesa = response.data.despesa;
            this.receita = response.data.receita;
            this.transacao = response.data.transacao;
            this.items_per_pag_receita = 10;
            this.items_per_pag_transacao = 10;
            this.items_per_pag_despesa = 10;
          }
        })
        .catch(err => {
          throw err;
        });
    },
    getEntidades() {
      Api.get(`/categorias-lancamentos/entidades`)
        .then(response => {
          if (response.data.data) {
            this.entidades = response.data.data;
          }
        })
        .catch(err => {
          throw err;
        });
    },
    temPai() {
      if (!this.nova_categoria.id_categoria) {
          return false;
      }
      if (this.nova_categoria.pai) {
        if (this.nova_categoria.pai.length <= 0) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    deleteItem() {
      Api.delete(`/categorias-lancamentos/` + this.formData.id_categoria)
        .then(response => {
          if (!response.data.errors) {
            this.$toast.success("Excluído com sucesso!");
            this.formData.id_categoria = "";
            this.getCategorias();
          } else {
            this.$toast.warning(response.data.errors);
            this.formData.id_categoria = "";
          }
        })
        .catch(err => {
          throw err;
        });
    },
    save() {
      if (this.$refs.form.validate()) {
        let rota = "";
        if (this.nova_categoria.id_categoria) {
          rota = "/" + this.nova_categoria.id_categoria;
        }
        this.loading = true;
        Api.post("/categorias-lancamentos" + rota, this.nova_categoria)
          .then(response => {
            this.loading = false;
            if (response.data.id_categoria) {
              this.$toast.success("Cadastrado com sucesso!");
            }
            this.getCategorias();
            this.$refs.form.reset();
            this.close();
          })
          .catch(err => {
            this.loading = false;
            this.$toast.error("Oops! Ocorreu um erro.");
            throw err;
          });
      }
    },

    close() {
      this.dialog_categoria = false;
      this.dialog_edit_categoria = false;
      this.nova_categoria = {
        categoria_nome: "",
        categoria_entidade: 0,
        categoria_associado: 0,
        categoria_cor: "#000000",
        categoria_entidade_padrao: "",
        tipo_lancamento: null
      };
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    carregarMaisDespesa() {
      if (this.despesa.length > this.items_per_pag_despesa) {
        this.items_per_pag_despesa += 10;
      }
    },
    carregarMaisReceita() {
      if (this.receita.length > this.items_per_pag_receita) {
        this.items_per_pag_receita += 10;
      }
    },
    carregarMaisTransacao() {
      if (this.transacao.length > this.items_per_pag_transacao) {
        this.items_per_pag_transacao += 10;
      }
    },

    vinculoAlterado() {
      if (this.vincular == "entidade") {
        this.nova_categoria.categoria_entidade = 1;
        this.nova_categoria.categoria_associado = 0;
      } else if (this.vincular == "associado") {
        this.nova_categoria.categoria_entidade = 0;
        this.nova_categoria.categoria_associado = 1;
        this.nova_categoria.categoria_entidade_padrao = "";
      } else {
        this.nova_categoria.categoria_entidade = 0;
        this.nova_categoria.categoria_associado = 0;
        this.nova_categoria.categoria_entidade_padrao = "";
      }
    },

    async validaEdicaoModulo() {
      this.editModulo = await Api.validaEdicaoModulo(
        this.$router.currentRoute.path
      );
    }
  },

  created() {
    this.getCategorias();
    this.getEntidades();
    this.validaEdicaoModulo();
  }
};
</script>

<style>
</style>